import { render, staticRenderFns } from "./ertong.vue?vue&type=template&id=29113faf&"
import script from "./ertong.vue?vue&type=script&lang=ts&"
export * from "./ertong.vue?vue&type=script&lang=ts&"
import style0 from "./ertong.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports